<template>
  <div class="mall-recent-purchase">
    <MallSectionTitle :title="'최근 구매 상품'" @more-click="$emit('more-click')" />
    <div class="mall-recent-purchase__body">
      <MallRoundTabs :tabs="tabs" :value="currentTab" @change="currentTab = $event" />
      <div class="mall-recent-purchase__products">
        <div v-for="item in visibleItems" :key="item.id" class="mall-recent-purchase__product">
          <MallProductCard
            :product="item"
            :showRebuy="true"
            @click="$emit('rebuy-click', item)"
            @rebuy-click="$emit('rebuy-click', item)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MallSectionTitle from '@/components/new/molecules/MallSectionTitle.vue'
import MallRoundTabs from '@/components/new/molecules/MallRoundTabs.vue'
import MallProductCard from '@/components/new/molecules/MallProductCard.vue'

export default {
  name: 'MallRecentPurchase',
  components: {
    MallSectionTitle,
    MallRoundTabs,
    MallProductCard,
  },
  props: {
    // [{ key, label }]
    tabs: {
      type: Array,
      required: true,
    },
    // 최근 구매 순으로 정렬된 상품 목록 [{ id, category, purchaseDate, ... }]
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentTab: this.tabs.length ? this.tabs[0].key : '',
    }
  },
  computed: {
    // 카테고리별 가장 최근에 구매한 상품 2개
    visibleItems() {
      return this.items.filter(item => item.category === this.currentTab).slice(0, 2)
    },
  },
  watch: {
    // 탭 목록이 바뀌어 선택한 탭이 없어지면 첫 탭으로
    tabs(tabs) {
      if (!tabs.some(tab => tab.key === this.currentTab)) {
        this.currentTab = tabs.length ? tabs[0].key : ''
      }
    },
  },
}
</script>

<style scoped>
.mall-recent-purchase {
  display: flex;
  padding: 0 16px;
  flex-direction: column;
  gap: 16px;
}

.mall-recent-purchase__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mall-recent-purchase__products {
  display: flex;
  gap: 8px;
}

.mall-recent-purchase__product {
  display: flex;
  width: calc((100% - 8px) / 2);
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallRecentPurchase.vue